const isBuildPhase = () =>
  globalThis?._env_?.NEXT_PUBLIC_IS_BUILD_PHASE === 'true';

export default isBuildPhase;
